/******************************************************************************
 * Droits d'auteur (c) 2024 Niralakka
 * 
 * La permission est accordée, gratuitement, à toute personne obtenant une copie de ce logiciel
 * et des fichiers de documentation associés (le "Logiciel"), de traiter le Logiciel sans restriction,
 * y compris, sans limitation, les droits d'utiliser, de copier, de modifier, de fusionner, de publier, de distribuer, de concéder
 * une sous-licence, et/ou de vendre des copies du Logiciel, et de permettre aux personnes à qui le Logiciel est fourni de le faire,
 * sous réserve des conditions suivantes :
 * 
 * L'avis de droit d'auteur ci-dessus et cet avis d'autorisation doivent être inclus dans toutes les copies ou parties substantielles
 * du Logiciel.
 * 
 * LE LOGICIEL EST FOURNI "TEL QUEL", SANS GARANTIE D'AUCUNE SORTE, EXPLICITE OU IMPLICITE,
 * Y COMPRIS, MAIS SANS S'Y LIMITER, LES GARANTIES DE QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE PARTICULIER ET D'ABSENCE DE CONTREFAÇON.
 * EN AUCUN CAS LES AUTEURS OU LES TITULAIRES DES DROITS D'AUTEUR NE SERONT RESPONSABLES DE TOUTE RÉCLAMATION, DOMMAGES OU AUTRE RESPONSABILITÉ,
 * QUE CE SOIT DANS UNE ACTION DE CONTRAT, DE DÉLIT OU AUTRE, DÉCOULANT DE, HORS DE OU EN LIEN AVEC LE LOGICIEL OU L'UTILISATION
 * OU D'AUTRES TRANSACTIONS DANS LE LOGICIEL.
 * 
 ******************************************************************************/

// Version: 1.0.0

/**
 * Classe pour la gestion des exceptions Niralakka
 * 
 * @version 1.0.0
 * 
 * @export
 * @class NrlkException
 * 
 * @constructor
 */
export class NrlkException extends Error {
    constructor(message, code = 0, type = '', response = '') {
        super(message);
        this.name = 'NiralakkaException';
        this.message = message;
        this.code = code;
        this.type = type;
        this.response = response;
    }
}